import { type RouteRecordRaw } from 'vue-router';

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "/admin/settings",
    component: () => import("./pages/SettingsLayout.vue"),
    meta: { role: "admin", title: "Configuración", requiresAdmin: true },
    children: [
      {
        path: "",
        name: "system-settings",
        component: () => import("./pages/SystemSettings.vue"),
        meta: { title: "Sistema" },
      },
    ],
  },
];
